import { create } from 'zustand';

interface MaintenanceState {
  /** Identity of the window the provider dismissed, or null while none has been dismissed. */
  readonly dismissedWindow: string | null;
  dismiss: (windowId: string) => void;
}

/**
 * Which maintenance window the provider has dismissed (US-018 AC-005).
 *
 * A shared store rather than component state for two reasons: the banner is mounted twice — once on the
 * login screen and once in the shell — so per-instance state would bring it back on the way in; and the
 * dismissal is keyed to a window's identity, so a *different* window announced later is not swallowed
 * by an earlier dismissal.
 *
 * UI state only, in memory, for the session. It holds no PHI and nothing is persisted.
 */
export const useMaintenanceStore = create<MaintenanceState>((set) => ({
  dismissedWindow: null,
  dismiss: (windowId): void => {
    set({ dismissedWindow: windowId });
  },
}));
